import { Sparkles } from "lucide-react";
import { Link } from "react-router";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { askZotHref, askZotKindLabel, type AskZotObjectKind } from "@/lib/ask-zot";

export function AskButton({
  kind,
  id,
  label,
  variant = "ghost",
  size = "sm",
}: {
  kind: AskZotObjectKind;
  id: string;
  label: string;
  variant?: "ghost" | "outline";
  size?: "sm" | "icon";
}) {
  const text = size === "icon" ? undefined : "Ask Zot";
  return (
    <Button variant={variant} size={size} asChild>
      <Link
        to={askZotHref(kind, id, label)}
        aria-label={`Ask Zot about ${askZotKindLabel(kind).toLowerCase()} ${label}`}
      >
        <Sparkles className="size-4" aria-hidden />
        {text ? <span className="ml-1">{text}</span> : null}
      </Link>
    </Button>
  );
}

export function ZotContextChip({ chip }: { chip: string | null }) {
  if (!chip) return null;
  return (
    <Badge variant="secondary" aria-label="Chat context">
      {chip}
    </Badge>
  );
}
